module.exports = __webpack_public_path__ + "img/logo.1cd064e4.png";